<script>
  import FetchController from './FetchController.vue';
  export default {
    extends: FetchController,
    methods: {
      getAllSurat(surattitle) {
        return this.fetchData(`/surat-search/get-all-surat?surattitle=${surattitle}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            console.log(data)
            if(data.result !== null) {
              return new Promise((resolve) => {
                resolve(data);
              })
            }
          })
      }
    }
  }
</script>